// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['appointmentDates', 'isPutting']);
export const getErrMsg = state => state.getIn(['appointmentDates', 'errMsg']);